// extracted by mini-css-extract-plugin
export var chevron = "_1t-d";
export var disabled = "_1t-b";
export var error = "_1t-c";
export var hideBorder = "_1t-1";
export var icon = "_1t-e";
export var input = "_1t-0";
export var large = "_1t-f";
export var open = "_1t-9";
export var placeholder = "_1t-a";
export var regular = "_1t-5";
export var singleRowInput = "_1t-2";
export var singleSelectInput = "_1t-3 _1t-0";
export var small = "_1t-4";
export var spinnerContainer = "_1t-i";
export var tag = "_1t-7";
export var tagsContainer = "_1t-8";
export var tagsInput = "_1t-6 _1t-0";
export var xSmall = "_1t-g";
export var xxSmall = "_1t-h";